import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => ({ is_hovered: props.is_hovered }), [props.is_hovered])
}
